import React from 'react';
import classnames from 'classnames';
import './index.scss';

export default function Exit({ className, text = '退出', ...other}) {
  return (
    <button className={classnames('exit-btn', className)} {...other} >
      <span className="shadow-box"></span>
      <span className="inner">
        <i className="icon-font">{'\ue612'}</i>
        {text}
      </span>
    </button>
  )
}